<template>
	<div :style="mainContentViewHeight" class="main_center">
		<div class="table-header">
				<searchBox
					:dialogVisible.sync="moreSearchItem"
					@dialogCancle="dialogCancle"
					title="更多筛选"
				>
					<div class="search-drawer">
						<el-form label-position="top" :model="moreSearchForm">
							<el-form-item label="数据所属部门：">
                            <select-depart-tree 
                            ref="selectDepartTreeRef"
                            :type="'2'"
                            :modelValue.sync="moreSearchForm.superviseDeptCodeList"  
                            :isMultiple="true" 
                            @handleDeptType="(val)=>changeDept(val,'5')" >
                            </select-depart-tree>
                        </el-form-item>
						</el-form>
                        <div class="search-drawer__footer">
                    <el-button @click="searchBtn" size="small" type="primary">查询</el-button>
                    <el-button @click="refresh" plain size="small">重置</el-button>
                </div>
					</div>
                   
				</searchBox>
				<div class="list_top">
                    <div class="pageTitle">公文流转</div>
				<div class="search">
					<el-input class="my_input" @keyup.enter.native="searchClick" v-model="searchKey" placeholder="请输入文件文号/文件名称进行搜索" clearable></el-input>
					<el-button type="primary" @click="searchClick" class="height_four">搜索</el-button>
					<el-button class="height_four" type="text" @click="moreSearchItem = true"><i class="el-icon-arrow-down" style="margin-right:5px;"></i>更多搜索</el-button>
					<!-- <el-divider direction="vertical"></el-divider>
                    <el-button icon="el-icon-refresh" type="text"></el-button> -->
				</div>
                </div>
			<el-tabs  v-model="activeName" @tab-click="tabClick">
				<el-tab-pane label="本部门发出" name="1"></el-tab-pane>
				<el-tab-pane label="本部门收到" name="2"></el-tab-pane>
			</el-tabs>
		</div>
		<div class="table-body tableContent_">
			<component 
				:is="isComponent" 
				:tableData="tableData" 
				@filterEmit="filterEmitHandle" 
				@sortEmit="sortEmitHandle" 
				@emitTableSearch="emitTableSearchHandle"
				@emitReload="emitReloadHandle"
				v-loading="dataListLoading"
			></component>
			<el-pagination
				background 
				layout="total, prev, pager, next" 
				:page-size="pageSize" 
				:total="total"
				:current-page="pageIndex"
				@size-change="sizeChangeHandle" 
				@current-change="currentChangeHandle">
			</el-pagination>
		</div>
	</div>
</template>
<script>
import IssusTbale from './components/IssusTbale.vue';
import ReceivedTabel from './components/ReceivedTabel.vue';
import {
	apiApplicationDocumentListPostDocument,
	apiApplicationDocumentListGetDocument
} from '@/server/synthesize.js';
import { mapState } from "vuex";
import selectDepartTree from "@/views/modules/components/selectDepartTree"
export default {
	name: "onlineTable",
	props: ['mainContentViewHeight'],
	components: {
		IssusTbale,
		ReceivedTabel,
        selectDepartTree
	},
	data() {
		return {
			tableMaxHeight: document.documentElement.clientHeight - 237,
			tableMaxHeightup: 400,
			dataListLoading: false,
			projectForm: {
				bidSectionName: '',
				receiveStatus: null,
				handleRate: null,
				handleStatus: null,
				complaintCode: '',
			},
			moreSearchItem: false,
            tableData: [],
			moreItem: true,
			pageSize: 10,//每页条数
			pageIndex: 1,//当前页
			total: 0,//总条数
			filter: {},
			sortParams: {
                prop:'modify_time',
                order:'desc'
            },
			processingStateList: [
				{ label: '已受理', value: 3 },
				{ label: '待受理', value: 1 },
				{ label: '不予受理', value: 2 },
			],
			tradeId:'',
			activeName:'1',
			formData: {
				receivingDeptName: '',
				createDeptName: ''
			},
			searchKey: '',
            moreSearchForm:{
                superviseDeptCodeList:[]
            },
		}
	},
    watch: {
        uerdefultOptionCode:{
        handler (val,oldVal){
          if(val.length!==0){
            this.activeName == '1'&&this.apiApplicationDocumentListPostDocument();
			this.activeName == '2'&&this.apiApplicationDocumentListGetDocument();
          }
        }
      }
    },
	computed: {
		isComponent() {
			let componentEnum = {
				'1': IssusTbale,
				'2': ReceivedTabel
			}
			return componentEnum[this.activeName]
		},
        ...mapState({
      uerdefultOptionCode: state => state.dataDictionary.uerdefultOptionCode,
			isAdmin: state => {return state.user.userinfo.selectRoleCode == "ADMIN"}
    })
	},
	mounted() {},
	activated() {
		if(this.$route.query.formType) {
			this.activeName = this.$route.query.formType;
			console.log(this.activeName)
			this.activeName == '1'&&this.apiApplicationDocumentListPostDocument();
			this.activeName == '2'&&this.apiApplicationDocumentListGetDocument();
		}else {
			this.apiApplicationDocumentListPostDocument();
		}
	},
	methods: {
        changeDept(val,str){//切换部门
            this.moreSearchForm.superviseDeptCodeList=[]
            if(str==='5'){
            // 多选
                val.forEach((item,index)=>{
                if( item.type!=="region"){
                    this.moreSearchForm.superviseDeptCodeList.push(item.id)
                }
            })
            }
        },
		dialogCancle(){
            this.moreSearchItem = false
        },
		tabClick() {//标签切换
			this.filter = {};
			this.activeName == '1'&&this.apiApplicationDocumentListPostDocument();
			this.activeName == '2'&&this.apiApplicationDocumentListGetDocument();
		},
		getWidth() {},
		apiApplicationDocumentListPostDocument() { //本部门发出列表数据
            this.filter.superviseDeptCodeList= this.moreSearchForm.superviseDeptCodeList.length==0?this.uerdefultOptionCode:this.moreSearchForm.superviseDeptCodeList
			this.dataListLoading = true;
            this.filter.tradeId=this.tradeId
			apiApplicationDocumentListPostDocument({
				page: this.pageIndex,
				rows: this.pageSize,
				filter: this.filter,
				searchKey: this.searchKey,
				orderBy: this.sortParams.prop && this.sortParams.order
					? this.sortParams.prop + (this.sortParams.order == "ascending" ? " asc" : " desc")
					: "",
			}).then(({data}) => {
                let dataList= data.rows || []
				this.tableData = dataList;
				this.total = data.total || 0;
			}).finally(() => {this.dataListLoading = false;})
		},
		apiApplicationDocumentListGetDocument() {//本部门接收列表数据
            this.filter.superviseDeptCodeList= this.moreSearchForm.superviseDeptCodeList.length==0?this.uerdefultOptionCode:this.moreSearchForm.superviseDeptCodeList
			this.dataListLoading = true;
            this.filter.tradeId=this.tradeId
			apiApplicationDocumentListGetDocument({
				page: this.pageIndex,
				rows: this.pageSize,
				searchKey: this.searchKey,
				filter: this.filter,
				orderBy: this.sortParams.prop && this.sortParams.order
					? this.sortParams.prop + (this.sortParams.order == "ascending" ? " asc" : " desc")
					: "",
			}).then(({data}) => {
				this.tableData = data.rows || [];
				this.total = data.total || 0;
			}).finally(() => {this.dataListLoading = false;})
		},
        //分页---------------------------------------------------
		sizeChangeHandle(val) {
			this.pageSize = val;
			this.pageIndex = 1
			this.activeName == '1'&&this.apiApplicationDocumentListPostDocument();
			this.activeName == '2'&&this.apiApplicationDocumentListGetDocument();
		},
		currentChangeHandle(val) {
			this.pageIndex = val
			this.activeName == '1'&&this.apiApplicationDocumentListPostDocument();
			this.activeName == '2'&&this.apiApplicationDocumentListGetDocument();
		},
		//搜索按钮
		handleSearch() {
			this.pageIndex = 1;
			this.activeName == '1'&&this.apiApplicationDocumentListPostDocument();
			this.activeName == '2'&&this.apiApplicationDocumentListGetDocument();
		},
		handleRefresh() {//刷新按钮
			this.pageIndex = 1;
			this.activeName == '1'&&this.apiApplicationDocumentListPostDocument();
			this.activeName == '2'&&this.apiApplicationDocumentListGetDocument();
		},
        searchBtn(){
            this.pageIndex = 1;
			this.activeName == '1'&&this.apiApplicationDocumentListPostDocument();
			this.activeName == '2'&&this.apiApplicationDocumentListGetDocument();
        },
        refresh(){
            this.moreSearchForm.superviseDeptCodeList=[]
           // 重置默认所属数据
           if( this.$refs.selectDepartTreeRef){
            this.$refs.selectDepartTreeRef.getUserTreeOption()
            }
         this.searchBtn();
        },
		formatterStatusClass(historyId) {
			switch (historyId) {
				case 3: return 'icon-point icon-point-success'; break;
				case 1: return 'icon-point icon-point-verificationing'; break;
				case 2: return 'icon-point icon-point-danger'; break;
				default: return ''; break;
			}
		},
		getDetail(row) { // 跳转详情
			removeTabHandle('officialDocProcessView')
			this.$router.push({
				name: 'officialDocProcessView',
				query: { id: row.id }
			})
		},
		filterEmitHandle(data) {//筛选处理
			let filtersParams = {};
			for(let i in data) {
				let filtersArr = data[i];
				let key = "",
				value = [];
				filtersArr.length>0 && filtersArr.forEach((item) => {
					key = item.split("_")[0];
					value.push(item.split("_")[1]);
				})
				key && value.length > 0 
					?(filtersParams[key] = value.toString())
					:null;
			}
			filtersParams.receivingDeptName = this.formData.receivingDeptName;
			filtersParams.createDeptName = this.formData.createDeptName;
			this.filter = filtersParams;
			this.activeName == '1'&&this.apiApplicationDocumentListPostDocument();
			this.activeName == '2'&&this.apiApplicationDocumentListGetDocument();
		},
		sortEmitHandle(data) {//排序处理
			let {column,order,prop} = data;
			this.sortParams.prop = this.toLowerLine(prop || column.prop);
			this.sortParams.order = order || column.order;
			this.activeName == '1'&&this.apiApplicationDocumentListPostDocument();
			this.activeName == '2'&&this.apiApplicationDocumentListGetDocument();
		},
		emitTableSearchHandle(arg) {//表格内部搜索
			let {type,data} = arg;
			if(type == 'receiving') {
				this.filter['receivingDeptName'] = data;
				this.formData['receivingDeptName'] = data;
				this.filter['createDeptName'] = '';
				this.formData['createDeptName'] = '';
			}
			if(type == 'create') {
				this.filter['createDeptName'] = data;
				this.formData['createDeptName'] = data;
				this.filter['receivingDeptName'] = '';
				this.formData['receivingDeptName'] = '';
			}
			this.activeName == '1'&&this.apiApplicationDocumentListPostDocument();
			this.activeName == '2'&&this.apiApplicationDocumentListGetDocument();
		},
		emitReloadHandle() {
			this.activeName == '1'&&this.apiApplicationDocumentListPostDocument();
			this.activeName == '2'&&this.apiApplicationDocumentListGetDocument();
		},
		searchClick() {
			this.activeName == '1'&&this.apiApplicationDocumentListPostDocument();
			this.activeName == '2'&&this.apiApplicationDocumentListGetDocument();
		},
		toLowerLine(str) {//驼峰转下划线
			let temp = str.replace(/[A-Z]/g, function(match) {
				return "_" + match.toLowerCase();
			});
			if(temp.slice(0,1) === '_'){ //如果首字母是大写，执行replace时会多一个_，这里需要去掉
				temp = temp.slice(1);
			}
			return temp;
		}
	}
}
</script>
<style lang="scss">
.table-header{
    .search{
        .el-input .el-input__inner, .el-input--medium .el-input__inner, .el-input--suffix .el-input__inner{
            border-top-right-radius: 0;
            border-bottom-right-radius: 0;
            }
    .height_four{
        height: 40px;
    }
     .el-input--medium .el-input__inner{
            height: 40px;
            line-height: 40px;
        }
    }
 
}
</style>
<style lang="scss" scoped>
$main-color:#1890FF;
.table-header {
	background: #ffffff;
	padding: 0 24px;
    padding-top:24px;
    .list_top{
            display: flex;
            align-items: center;
        }
       
	// box-shadow: 0 2px 4px 0 rgba(0, 0, 0, .12), 0 0 6px 0 rgba(0, 0, 0, .04);
	.table-header--top {
		display: flex;
		align-items: center;
		// margin: 20px 0;
	}
    .pageTitle{
            font-size: 18px;
            font-weight: 600;
            color: #000000; 
            height: 40px; 
         }
	.search{
		width:calc(100% - 80px);
        height:40px;
		float: none;
		display: flex;
		justify-content: center;
		align-items: center;
		>.my_input{
			width: 500px;
		}
		>.el-button--primary{
			background-color: $main-color;
			border-color: $main-color;
		}
	}
}
.table-body{
	// margin:16px 24px;
	background: #ffffff;
	// padding: 15px 24px;
	margin-bottom: 0;
}
</style>
